import { IDictionary } from '@common/interfaces/dictionary.interface';

export const queryToString = (data: IDictionary): string => {
    return Object.keys(data)
        .filter((key) => data && data[key] !== undefined)
        .map((key) => {
            return `${key}=${encodeURIComponent(data[key])}`;
        })
        .join('&');
};
